// Qué le pasó a un clip, en palabras — ADR-2026-11-03-los-errores-del-estudio-se-ven.
//
// Cada proceso guarda su error en un campo propio (`aiError`, `eraseError`,
// `corregirVozError`…) y hasta ahora el motivo sólo se veía como `title` del badge o del
// botón Reintentar: al pasar el mouse, y en el teléfono nunca. Esto elige el que hay que
// mostrar (uno, el más importante primero) para el aviso del clip seleccionado.

export interface ClipConErrores {
  type: string;
  aiStatus?: string;
  aiError?: string;
  aiTranslateError?: string;
  eraseStatus?: string;
  eraseError?: string;
  corregirVozStatus?: string;
  corregirVozError?: string;
  pasarA1080pStatus?: string;
  pasarA1080pError?: string;
  voiceChangeStatus?: string;
  voiceChangeError?: string;
  aiAssetWarning?: string;
  loadError?: string;
}

export interface MotivoDelClip {
  titulo: string;
  motivo: string;
  /** Es un error de la escena / el audio con IA: el aviso ofrece Reintentar. */
  reintentable: boolean;
}

const limpio = (t?: string) => (t ?? '').trim();

export function motivoDelClip(c: ClipConErrores): MotivoDelClip | null {
  if (limpio(c.loadError))
    return { titulo: 'No se pudo cargar el archivo', motivo: limpio(c.loadError), reintentable: false };
  if (c.aiStatus === 'error')
    return {
      titulo: c.type === 'audio' ? 'No se pudo generar el audio' : 'No se pudo generar la escena',
      motivo: limpio(c.aiError) || 'Algo falló al generarla. Probá de nuevo.',
      reintentable: true,
    };
  if (limpio(c.aiTranslateError))
    return { titulo: 'No se pudo traducir', motivo: limpio(c.aiTranslateError), reintentable: false };
  if (c.eraseStatus === 'error')
    return {
      titulo: 'No se pudo borrar el objeto',
      motivo: limpio(c.eraseError) || 'Algo falló al borrarlo. Probá de nuevo.',
      reintentable: false,
    };
  if (c.corregirVozStatus === 'error')
    return {
      titulo: 'No se pudo corregir la voz',
      motivo: limpio(c.corregirVozError) || 'Algo falló al corregirla. Probá de nuevo.',
      reintentable: false,
    };
  if (c.voiceChangeStatus === 'error')
    return {
      titulo: 'No se pudo cambiar la voz',
      motivo: limpio(c.voiceChangeError) || 'Algo falló al cambiarla. Probá de nuevo.',
      reintentable: false,
    };
  if (c.pasarA1080pStatus === 'error')
    return {
      titulo: 'No se pudo pasar a 1080p',
      motivo: limpio(c.pasarA1080pError) || 'Algo falló. Probá de nuevo.',
      reintentable: false,
    };
  if (limpio(c.aiAssetWarning))
    return { titulo: 'Ojo con este clip', motivo: limpio(c.aiAssetWarning), reintentable: false };
  return null;
}
